import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractService, Config } from '@increff/commons';
import { Observable } from 'rxjs';
import { APP_RESOURCE, APP_ROLE, DOMAIN_ROLE } from '../../interfaces/application.interface';
import { DOMAIN_RESOURCE } from '../../interfaces/resource.interface';
import { Rest } from '../rest.service';

@Injectable({
    providedIn: 'root'
})
export class ManagementService {

    public appNamesMap: Record<string, {[key: string]: APP_ROLE | any}> = {};

    constructor(
      private abstractService: AbstractService,
      private urls: Rest,
      private config: Config
    ) { }

    getAllRoles(appName?: string, appResourceId?: number, domainResourceId?: number, type: 'admin' | 'domain' = 'admin'): Observable<APP_ROLE[]> {
        const params = new HttpParams()?.set('appName', appName);
        let headers = new HttpHeaders();
        appResourceId ? headers = headers?.set('appResourceId', `${appResourceId}`) : '';
        domainResourceId ? headers = headers?.set('domainResourceId', `${domainResourceId}`) : '';
        return this.abstractService.exec(
            type === 'admin' ? this.urls.allAdminRolesUrl : this.urls.allDomainRolesUrl,
            'GET',
            undefined,
            type === 'admin' ? {params, headers, ...this.config?.startupData?.extraHttpOptions} : {headers, ...this.config?.startupData?.extraHttpOptions}
        );
    }

    getAllUserRoles (appName?: string, type: 'admin' | 'domain' = 'admin'): Observable<APP_ROLE[]> {
        const params = new HttpParams()?.set('appName', appName);
        return this.abstractService.exec(
            type === 'admin' ? this.urls.allAdminRolesUrl : this.urls.allDomainUserRolesUrl,
            'GET',
            undefined,
            type === 'admin' ? {params, ...this.config?.startupData?.extraHttpOptions} : { ...this.config?.startupData?.extraHttpOptions }
        );
    }

    getUserRoles(userId: number, domainId?: number, domainResourceId?: number, type: 'admin' | 'domain' = 'admin'): Observable<DOMAIN_ROLE[]> {
        const params = domainId ? new HttpParams()?.set('domainId', domainId) : '';
        const headers = domainResourceId ? new HttpHeaders()?.set('domainResourceId', `${domainResourceId}`) : '';
        return this.abstractService.exec(
            type === 'admin' ? this.urls.getAdminUserRolesUrl(userId) : this.urls.getDomainUserRolesUrl(userId),
            'GET',
            undefined,
            type === 'admin' ? {params, headers, ...this.config?.startupData?.extraHttpOptions} : {headers, ...this.config?.startupData?.extraHttpOptions}
        );
    }

    updateUserRoles(userId: number, roleList: Array<number> = [], domainId?: number, domainResourceId?: number, type: 'admin' | 'domain' = 'admin'): Observable<void> {
        let params = new HttpParams();
        type === 'admin' ? params = params?.set('domainId', domainId) : '';
        let headers = new HttpHeaders();
        domainResourceId ? headers = headers.set('domainResourceId', `${domainResourceId}`) : '';
        return this.abstractService.exec(
            type === 'admin' ? this.urls.getUpdateAdminUserRolesUrl(userId) : this.urls.getUpdateDomainUserRolesUrl(userId),
            'POST',
            roleList,
            type === 'admin' ? {params, headers, ...this.config?.startupData?.extraHttpOptions} : {headers, ...this.config?.startupData?.extraHttpOptions}
        );
    }

    getApplicationResources(appName?: string): Observable<APP_RESOURCE[]>{
        const params = new HttpParams()?.set('appName', appName);
        return this.abstractService?.exec(
            appName ? this.urls.adminApplicationResourcesUrl : this.urls.domainApplicationResourcesUrl,
            'GET',
            undefined,
            appName ? {params, ...this.config?.startupData?.extraHttpOptions} : { ...this.config?.startupData?.extraHttpOptions }
        );
    }

    getAllDomainResources(): Observable<DOMAIN_RESOURCE[]> {
        return this.abstractService.exec(
            this.urls?.allDomainResourcesUrl,
            'GET',
            undefined,
            { ...this.config?.startupData?.extraHttpOptions }
        );
    }

    createDomainResource(resourceDetails: DOMAIN_RESOURCE): Observable<void> {
        return this.abstractService.exec(
            this.urls?.createDomainResourceUrl,
            'POST',
            resourceDetails,
            { ...this.config?.startupData?.extraHttpOptions}
        );
    }
}
